
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kotak_surat",
      function () {
        return require("private-next-pages/kotak_surat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kotak_surat"])
      });
    }
  